<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">
        {{ $t("edit") }} Tier {{ $t("type") }}
      </div>
      <router-link class="btn-blue" :to="{ name: 'Cinema Types' }"
        >Tier {{ $t("type") }} {{ $tc("list", 1) }}</router-link
      >
    </div>

    <div class="white-wrapper" style="padding: 10px 20px">
      <div class="row" style="height: 55px">
        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <!-- @focus="onFocusHandler" -->
              <!-- :required="item.required" -->
              <input
                id="tier_type_name"
                name="tier_type_name"
                v-validate="{ required: 'required', regex: /^[a-zA-Z0-9 ]*$/ }"
                v-model="tier_type_name"
                placeholder="."
                v-b-tooltip.hover
                :title="$t('tier_type_name')"
              />
              <label>Tier Type Name</label>
            </div>
            <!--Tooltip :title="$t('tier_type_name')" /-->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('tier_type_name')">{{
              errors.first("tier_type_name")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center pt-3">
            <b-form-checkbox
              type="checkbox"
              class="j-checkbox"
              v-model="tier_type_is_active"
              true-value="Y"
              false-value="N"
            />

            <label class="mb-0 mr-3">{{ $t("active") }}</label>
          </div>
        </div>

        <div class="text-center btn_position" style="">
          <button @click.prevent.stop="editTierType()" class="btn-blue">
            {{ $t("update") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      submitted: false,
      tier_type_name: "",
      tier_type_is_active: true,
      tier_type_id: null,
    };
  },
  mounted() {
    const { tier_type_id } = this.$route.params;
    if (tier_type_id) {
      this.getTierTypeData(tier_type_id);
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    getTierTypeData: function (tier_type_id) {
      MasterService.GetTierTypeData({ tier_type_id: tier_type_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.tier_type_name = data.Records[0].tier_type_name;
            this.tier_type_is_active =
              data.Records[0].tier_type_is_active == "Y" ? true : false;
            this.tier_type_id = data.Records[0].tier_type_id;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    editTierType() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          // let loader = this.$loading.show();

          // console.log("JSON.stringify :", JSON.stringify(finalObj));
          let payload = {
            tier_type_id: this.tier_type_id,
            tier_type_name: this.tier_type_name,
            tier_type_is_active: this.tier_type_is_active ? "Y" : "N",
          };
          MasterService.EditTierType(payload)
            .then((response) => {
              const { data } = response;
              // loader.hide();
              if (data && data.status) {
                this.$toasted.show(data.message);

                this.$router.push({
                  path: "/master/tier-types",
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/TierTypeComponents/editTierType.vue